import React from 'react'
import { CoachMessege } from '../../../CoachModule/Messege/Page/CoachMessege'
import {MessegesComponent} from '../../../Messeges/Pages/Messeges'

export const JobSeekMessege = () => {
return (
    <MessegesComponent jobSeek={true} />
)
}